// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"a0616324","493":"2fe3fb1b","517":"ef8f2024","724":"41eaaa5a","980":"32a2b48c"}[chunkId] + ".chunk.js";
};